<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiBullhornOutline } from "@mdi/js";
export default {
  name: "MdiBullhornOutline",
  data() {
    return {
      svgPath: mdiBullhornOutline,
    };
  },
};
</script>
